import * as React from 'react';
import { Button } from 'antd';
import { Link } from 'gatsby';
import SEO from '_components/seo_v3';
import { createBreadcrumbData } from '_utils/structuredData';
import image404 from '_images/404image.svg';
import '_styles/404.less';
import Header from '_components/HeaderV2';
import FooterV3 from '_components/FooterV3/FooterV3';
import Layout from '_components/layout';

const NotFoundPage = () => (
  <Layout mode="fluid" v3>
    <main className="pt-[71px] lg:pt-[40px]">
      <div className="not-found-page-wrapper max-w-[1440px] mx-auto px-4 md:px-8 xl:px-16">
        <div className="image-404 flex justify-center">
          <img src={image404} alt="Page Not Found" className="w-[280px] md:w-[320px]" />
        </div>
        <div className="os-text-50 mt-4 text-center">Sorry!</div>
        <div className="os-text-24 font-extrabold mt-2 text-center pl-2 pr-2">
          We looked everywhere, but couldn't find the page you requested.
        </div>
        <div className="text-center mt-6">
          <Link to="/">
            <Button size="large" type="primary">
              Go to Homepage
            </Button>
          </Link>
        </div>
        <div className="mt-6 text-center mb-6">
          <h2 className="text-xl font-bold mb-3">You might be interested in:</h2>
          <div className="space-y-2">
            <div><Link to="/new-cars/price-lists">New Car Price Lists</Link></div>
            <div><Link to="/articles">Latest Articles</Link></div>
            <div><Link to="/car-loan">Car Loans</Link></div>
            <div><Link to="/sell-my-car-online-to-dealer-singapore">Sell Your Car</Link></div>
          </div>
        </div>
      </div>
    </main>
  </Layout>
);

export const Head = ({ location, params, data, pageContext }) => {
  const title = "Page Not Found | OneShift by Carousell";
  const description = "We're sorry, but we couldn't find the page you're looking for. Please check out our latest car listings, reviews, and automotive services.";
  
  const structuredDataWithoutUrl = (siteUrl) => {
    // Create breadcrumb data
    const breadcrumbData = createBreadcrumbData([
      { name: 'Home', path: '/' },
      { name: 'Page Not Found', path: location.pathname }
    ], siteUrl);

    return [breadcrumbData];
  };

  return <SEO 
    title={title} 
    description={description} 
    pathname={location.pathname}
    getStructuredData={structuredDataWithoutUrl}
  />
}

export default NotFoundPage;
